<template>
    <div class="privacy-container">
      <h1>隱私權政策</h1>
  
      <p>
        感謝您使用雲林縣政府「雲林農情通」行動應用服務。
        本行動應用服務重視您的個人隱私權，並致力於妥善保護您所提供的個人資料，
        為協助您瞭解「雲林農情通」如何蒐集、運用及保護您的個人資訊，
        請詳閱以下隱私權政策內容。
      </p>
  
      <h2>一、隱私權政策適用範圍</h2>
      <p>
        本隱私權政策適用於您在使用「雲林農情通」行動應用服務過程中，
        所涉及之個人資料蒐集、處理、利用與保護行為。
      </p>
      <p>
        本政策不適用於經由本行動應用服務連結至之外部網站或其他政府機關及第三方行動應用服務。
        該等外部網站均有其各自之隱私權政策，本行動應用服務不負任何連帶責任。
      </p>
  
      <h2>二、個人資料之蒐集、處理及利用</h2>
      <ul>
        <li>蒐集項目：姓名、手機號碼（作為身分驗證與服務識別之用途）。</li>
        <li>
          未經您本人同意，不會任意修改或刪除您的個人資料，但下列情形不在此限：
          <ol>
            <li>依法令或合法程序辦理。</li>
            <li>使用行為違反服務相關規定。</li>
            <li>為保護其他使用者或第三人之合法權益。</li>
            <li>為維護本服務正常運作。</li>
          </ol>
        </li>
        <li>
          個人資料不會任意提供第三人，但下列情形得依法提供：
          <ol>
            <li>配合司法機關調查。</li>
            <li>配合主管機關依法執行職務。</li>
            <li>為維護本服務管理與安全所必要。</li>
          </ol>
        </li>
        <li>
          蒐集目的：調查、統計與研究分析、資訊服務、資訊與資料庫管理、
          資訊安全管理、會員管理及其他諮詢與顧問服務。
        </li>
      </ul>
  
      <h3>個人資料利用說明</h3>
      <ol>
        <li>期間：本府營運期間及依法令規定之保存期間。</li>
        <li>地區：本府營運地區。</li>
        <li>對象：本府及受委託之關係企業與合作廠商。</li>
        <li>方式：提供活動資訊、市場調查或服務提醒訊息。</li>
      </ol>
  
      <p>
        您得依個人資料保護法行使查詢、閱覽、補充更正、停止利用或刪除等權利，
        本府將依法審酌是否受理。
      </p>
  
      <p>
        本府將以嚴密的資訊安全措施保護您的個人資料，
        並要求受委託單位遵守保密義務。
      </p>
  
      <p>
        <strong>Cookie 使用說明：</strong>
        為提供更完善的服務，本平台可能使用 Cookie 以分析使用行為與改善服務品質。
      </p>
  
      <h2>三、設備權限使用說明</h2>
      <p>
        「雲林農情通」將依功能需求請求必要之設備權限（如通知）。
        使用者可於裝置設定中自行管理，未授權僅影響該項功能。
      </p>
  
      <h2>四、使用者應盡之義務</h2>
      <ul>
        <li>提供不實資料者，本服務得拒絕其使用權限。</li>
        <li>帳號安全須由使用者自行妥善保管。</li>
        <li>如帳號遭盜用，請立即通知服務信箱。</li>
        <li>使用者應遵守相關法令，並對帳號行為負責。</li>
      </ul>
  
      <h2>五、隱私權政策諮詢</h2>
      <ul>
        <li>
          服務信箱：
          <a href="mailto:ylhg40118@mail.yunlin.gov.tw">
            ylhg40118@mail.yunlin.gov.tw
          </a>
        </li>
        <li>如有違反本政策之情事，歡迎來信檢舉。</li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Privacy'
  }
  </script>
  
  <style scoped>
  .privacy-container {
    max-width: 960px;
    margin: auto;
  
    /* 👇 上下 / 左右 padding */
    padding: 40px 24px;
  
    line-height: 1.8;
  }
  
  h1 {
    margin-bottom: 24px;
  }
  
  h2 {
    margin-top: 32px;
  }
  
  h3 {
    margin-top: 24px;
  }
  
  ul,
  ol {
    padding-left: 24px;
  }
  </style>
  